export default __webpack_public_path__ + "static/media/file.9b86cf6c.mov";